<template>
  <div>

    <div class="card card-info">
      <div class="card-header with-border">
        <h3 class="card-title">List</h3>
      </div>
      <div class="card-body ">
        <div class="row">
            <div class="col-md-12">
                <div class="form-group">
                    <div class="table-responsive" style="padding-bottom: 20px;">
                        <table id="tblJobOffering" class="table">
                            <thead>
                                <tr>
                                    <th>Job Title</th>
                                    <th>Job Details</th>
                                    <th style="white-space: nowrap">Valid Till</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="item in lst">
                                    <td>
                                        {{item.JobTitle}}
                                        <span v-if="!item.IsClosed" class="badge badge-success">Open</span>
                                        <span v-else class="badge badge-danger">Closed</span>
                                    </td>
                                    <td>    <button class="btn btn-success btn-sm" type="submit" v-on:click="viewDetail(item.JobOfferingID)">View Details</button></td>
                                    <td style="white-space: nowrap">{{item.LastDate}}</td>
                                    <td style="white-space: nowrap">

                                        <button v-if="!item.IsClosed" class="btn btn-primary btn-sm" type="button" v-on:click="applyNow(item.JobOfferingID)">Apply Now</button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
      </div>
    </div>
    <div class="modal fade" id="mdlPatientRecord">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header bg-primary">
            <h4 class="modal-title">Job Details</h4>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-md-12">
                <!--<div class="form-group">
                  <label>Effective To *</label>
                  <input v-model="merit.EffectiveTo" type="date" class="form-control" />
                </div>-->
                <div v-html="detail.Description"></div>
              </div>
            </div>
          </div>
          <div class="modal-footer ">
            <button type="button" class="btn btn-default" data-dismiss="modal">
              Close
            </button>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
    </div>
  </div>
</template>

<script>const axios = require('axios').default;

    export default ({
        data() {
            return {
                lst: [],
                detail: ''
            }
        },
        created: function () {
            this.pageLoad();
        },
        updated: function () {
            $('#tblJobOffering').DataTable();
        },
        methods:
        {
            pageLoad() {
                startReq();
                var vm = this;
                axios.post('/ApplicantsApi/pageLoadJobOfferingDashboard')
                    .then(function (response) {
                        if (response.data.status) {
                            endReq();
                            vm.lst = response.data.lst;
                        }
                        else {
                            endReq();
                            toastr.error(response.data.msg, "Error!");
                        }
                    })
            },
            viewDetail(interID) {
                var vm = this;
                axios.post("/ApplicantsApi/jobDetails?ID=" + interID)
                    .then(function (res) {
                        if (res.data.status) {
                            vm.detail = res.data.obj;
                            $('#mdlPatientRecord').modal('show');
                        }
                        else {
                            toastr.error(res.data.msg);
                        }
                    })
                    .catch(function (error) {

                    });

            },
            applyNow(id) {
                var vm = this;
                axios.post("/ApplicantsApi/saveJobID?ID=" + id)
                    .then(function (res) {
                        if (res.data.status) {
                            window.location.href = '../Jobs/ApplyForJob'
                        }
                        else {
                            toastr.error(res.data.msg);
                        }
                    })
                    .catch(function (error) {

                    });
            }
        }
    });</script>



// WEBPACK FOOTER //
// src/components/jobOfferingDashboard.vue